import { query, mutation } from '@/services/graphql';
import * as operations from './operations';

export default {
  getCourseList(variables = {}) {
    return query(operations.COURSES_LIST, variables, true);
  },
  getCourseData(variables = {}) {
    return query(operations.COURSE_DATA, variables, true, { showErrorMessage: false });
  },
  getCourseChapters(variables = {}) {
    return query(operations.COURSE_CHAPTERS, variables, true);
  },
  getCourseSections(variables = {}) {
    return query(operations.COURSE_SECTIONS, variables, true, { showErrorMessage: false });
  },
  getCourseProgress(variables = {}) {
    return query(operations.COURSE_PROGRESS, variables, true);
  },
  getWrongRecords(variables = {}) {
    return query(operations.WRONG_RECORDS, variables, true);
  },
  getExamScore(variables = {}) {
    return query(operations.EXAMSCORE, variables, true);
  },
  getCourseExamRecords(variables = {}) {
    return query(operations.COURSE_EXAM_RECORDS, variables, true);
  },
  learningVideo(variables = {}) {
    return query(operations.LEARING_VIDEO, variables, true, { showErrorMessage: false });
  },
  submitCourseResult(variables = {}) {
    return mutation(operations.COURSE_RESULT, variables, true);
  },
  readBook(variables = {}) {
    return mutation(operations.READ_BOOK, variables, true);
  },
};
